import { request } from "./authApi";

// Public: matches the backend's Section A /pinned-home-cards route.
// Returns every card an admin has pinned to the homepage's "مقاله‌های
// منتخب" row, ordered for display, alongside that row's
// automatically-listed articles (see HomePage.js). Each entry has a
// "kind" of either "topic" (a نشریه/Publication card) or "issue_topic"
// (a شماره/Issue card) — see which one tells you whether
// publication_slug or issue_id is set.
export function getPinnedHomeCards() {
  return request("/pinned-home-cards");
}

// Admin only (Section C). kind is "topic" or "issue_topic"; id is that
// card's own id. Pinning an already-pinned card is a no-op on the
// backend, not an error.
export function pinHomeCard(token, kind, id) {
  return request("/pinned-home-cards", { method: "POST", body: { kind, id }, token });
}

export function unpinHomeCard(token, kind, id) {
  return request(`/pinned-home-cards/${kind}/${id}`, { method: "DELETE", token });
}

// cards is every currently-pinned card — [{ kind, id }, ...] — in its
// new combined display order (see AdminPinnedHomePage.js's move
// up/down buttons).
export function reorderPinnedHomeCards(token, cards) {
  return request("/pinned-home-cards/reorder", {
    method: "PUT",
    token,
    body: { cards },
  });
}
